const flakeyLaunchDarklyErrorMatcher = /^NetworkError:.*events\.launchdarkly\.com\/events\/bulk/i;

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const isNotWorthRecordingError = (err: any): boolean => {
  return flakeyLaunchDarklyErrorMatcher.test(`${err}`);
};

export type OnUncaughtErrorCallback = (event: ErrorEvent) => any;
export type OnUnhandledRejectionCallback = (event: PromiseRejectionEvent) => any;

export type ListenerObject = {
  uncaughtError: OnUncaughtErrorCallback;
  unhandledRejection: OnUnhandledRejectionCallback;
};

export type AddRecordableErrorEventListenersOutput = {
  removeEventListener: () => void;
};

export const addRecordableErrorEventListeners = (listeners: ListenerObject): AddRecordableErrorEventListenersOutput => {
  const onUncaughtError: OnUncaughtErrorCallback = (err) => {
    if (isNotWorthRecordingError(err)) {
      return;
    }

    listeners.uncaughtError(err);
  };

  const onUnhandledRejection = listeners.unhandledRejection;

  globalThis.addEventListener('error', onUncaughtError);
  globalThis.addEventListener('unhandledrejection', onUnhandledRejection);

  return {
    removeEventListener: () => {
      globalThis.removeEventListener('error', onUncaughtError);
      globalThis.removeEventListener('unhandledrejection', onUnhandledRejection);
    },
  };
};
